export class PqrMailStatusEntity{
    id:number;
    mailId:number;
    statusId:number;

    constructor(){}
}